module.exports = __webpack_public_path__ + "static/media/Termometer.9f18fea9.m4a";